'use client';

import { useEffect, useState, Suspense } from 'react';
import { createPortal } from 'react-dom';

import { LocationSection } from './location-section.component';
import { useHandleLocation } from './use-handle-location.hook';

interface LocationSectionPortalProps {
  city?: string;
  state?: string;
}

function LocationSectionPortalContent({ city, state }: LocationSectionPortalProps) {
  const [container, setContainer] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setContainer(document.getElementById('header-location-slot'));
  }, []);

  useHandleLocation({ city, state });

  if (!container) {
    return null;
  }

  return createPortal(<LocationSection />, container);
}

export function LocationSectionPortal({ city, state }: LocationSectionPortalProps) {
  return (
    <Suspense fallback={null}>
      <LocationSectionPortalContent city={city} state={state} />
    </Suspense>
  );
}
